<img
  src="{{ this.bannerGraphic }}"
  alt=""
  role="presentation"
  loading="eager"
  priority />
